export const getQaaSearchId = (type: string, placeholder: string) =>
	`qaa-${type}-${placeholder.split('/')[0].trim().replace(/\s+/g, '-').toLowerCase()}`

export const getQaaInputId = (label: string) => {
	if (!label) {
		return null
	}

	return `qaa-${label.toLowerCase().trim().replace(/\s+/g, '-').replace(':', '')}`
}
